

const SPLIDE_MODULE_URL = "//www.dekah.ie/cdn/shop/t/3/assets/splide.esm.js?v=42432906053591983441779079760";

let splideModulePromise = null;



function loadSplide() {

    if (!splideModulePromise) {

        splideModulePromise = import(SPLIDE_MODULE_URL);

    }

    return splideModulePromise;

}



class SplideSlider extends HTMLElement {

    connectedCallback() {

        if (this.dataset.desktopHidden === 'wide' && window.innerWidth > 991) return;

        if (this._initStarted) return;

        this._initStarted = true;



        if (this.shouldMountEager()) {

            this.runLoadAndInit();

        } else {

            this.scheduleLazyInitialize();

        }

    }



    disconnectedCallback() {

        if (this._ioObserver) {

            this._ioObserver.disconnect();

            this._ioObserver = null;

        }

        clearTimeout(this._lazyFallbackTimer);

    }



    shouldMountEager() {

        return (

            this.dataset.sliderType === 'sync' ||

            this.dataset.splideEager === 'true'

        );

    }



    scheduleLazyInitialize() {

        const observer = new IntersectionObserver(

            (entries) => {

                for (const entry of entries) {

                    if (entry.isIntersecting) {

                        observer.disconnect();

                        this._ioObserver = null;

                        clearTimeout(this._lazyFallbackTimer);

                        this.runLoadAndInit();

                        break;

                    }

                }

            },

            { root: null, rootMargin: '200px 0px 200px 0px', threshold: 0 }

        );

        observer.observe(this);

        this._ioObserver = observer;



        this._lazyFallbackTimer = setTimeout(() => {
            if (!this.slider && document.visibilityState === 'visible') {
              this.runLoadAndInit();
            }
          }, 4000);

    }



    runLoadAndInit() {

        if (this.dataset.desktopHidden === 'wide' && window.innerWidth > 991) return;

        if (this.slider) return;

        if (this._loadInFlight) return;

        this._loadInFlight = true;



        loadSplide()

            .then((mod) => {

                if (!this.isConnected) return;

                if (this.slider) return;

                const Splide = mod.default;

                this.initialize(Splide);

                if (this.slider) {

                    this.dispatchEvent(

                        new CustomEvent('splide-slider:ready', {

                            bubbles: true,

                            detail: { slider: this.slider },

                        })

                    );

                }

            })

            .catch(() => {

                this._initStarted = false;

            })

            .finally(() => {

                this._loadInFlight = false;

            });

    }



    initialize(Splide) {

        if (this.dataset.desktopHidden === 'wide' && window.innerWidth > 991) return;

        this.slider = null;

        const initializeSplide = (element, options, autoMount = true) => {

            const splide = new Splide(element, options);

            if (this.dataset.progress === 'true') {

                var bar = splide.root.querySelector('[data-splide-progress]');

                splide.on('mounted move', function () {

                    var end = splide.Components.Controller.getEnd() + 1;

                    var rate = Math.min((splide.index + 1) / end, 1);

                    bar.style.width = String(100 * rate) + '%';

                });

            }



            const mountSplide = () => {

                splide.mount();

                const sliderList = this.querySelectorAll('.splide__list');

                sliderList.forEach((list) => {

                    list.classList.remove('splide-slider--h-scroll');

                });

            };



            if (autoMount) {

                mountSplide();

            }



            splide.on('inactive', (slide) => SplideSlider.inactiveEvent(slide));

            if (this.dataset.refPicker === 'true' && window.innerWidth > 991) {

                splide.on('active', (slide) => {

                    SplideSlider.goToReference(slide.index);

                });

            }

            if (this.dataset.destroyedUp) {

                if (window.innerWidth > parseFloat(this.dataset.destroyedUp)) {

                    const slides = this.querySelectorAll('.splide__slide');

                    slides.forEach((slide) => {

                        slide.removeAttribute('tabindex');

                        slide

                            .querySelectorAll('a[tabindex="-1"], button[tabindex="-1"]')

                            .forEach((el) => el.removeAttribute('tabindex'));

                    });

                }

            }

            return {

                splide,

                mount: mountSplide,

            };

        };

        switch (this.dataset.sliderType) {

            case 'sync':

                const mpElem = this.querySelector('[data-main-thumbs]');

                const swElem = this.querySelector('[data-switcher-thumbs]');

                if (!mpElem || !swElem) return;

                const mpOpts = JSON.parse(mpElem.getAttribute('data-splide'));

                const swOpts = JSON.parse(swElem.getAttribute('data-splide'));

                const mpInstance = initializeSplide(mpElem, mpOpts, false);

                const swInstance = initializeSplide(swElem, swOpts, false);



                mpInstance.splide.sync(swInstance.splide);

                mpInstance.mount();

                swInstance.mount();



                const galleryPrev = this.querySelector('[data-gallery-prev]');

                const galleryNext = this.querySelector('[data-gallery-next]');

                if (galleryPrev && galleryNext) {

                    const splide = mpInstance.splide;

                    const updateGalleryArrows = () => {

                        galleryPrev.disabled = Math.max(splide.index, 0) === 0;

                        galleryNext.disabled =

                            Math.min(splide.index, splide.length - 1) === splide.length - 1;

                    };

                    galleryPrev.addEventListener('click', () =>

                        splide.go(String.fromCharCode(60))

                    );

                    galleryNext.addEventListener('click', () =>

                        splide.go(String.fromCharCode(62))

                    );

                    updateGalleryArrows();

                    splide.on('move', updateGalleryArrows);

                }

                if (mpElem.classList.contains('product-gallery-main')) {

                    const mainSplide = mpInstance.splide;

                    const track = mpElem.querySelector('.splide__track');

                    // Keep focus within the currently active slide.
                    // Fixes cases where Tab focuses interactive media (e.g., <video>) inside an aria-hidden slide.
                    const focusableSelector = 'a[href], button, input:not([type="hidden"]), select, textarea, [tabindex]';
                    const setSlideFocusable = (slideEl, enabled) => {
                        if (!slideEl) return;
                        slideEl.querySelectorAll(focusableSelector).forEach((el) => {
                            // Don't modify disabled controls; and don't clobber explicit tabindex="-1" on purposefully skipped items
                            if (!el || el.disabled) return;
                            const cur = el.getAttribute('tabindex');
                            if (!enabled) {
                                if (cur === '-1') return;
                                if (!el.hasAttribute('data-prev-tabindex')) {
                                    el.setAttribute('data-prev-tabindex', cur == null ? '' : cur);
                                }
                                el.setAttribute('tabindex', '-1');
                            } else {
                                if (el.hasAttribute('data-prev-tabindex')) {
                                    const prev = el.getAttribute('data-prev-tabindex');
                                    el.removeAttribute('data-prev-tabindex');
                                    if (prev === '') el.removeAttribute('tabindex');
                                    else el.setAttribute('tabindex', prev);
                                } else if (el.getAttribute('tabindex') === '-1') {
                                    el.removeAttribute('tabindex');
                                }
                            }
                        });
                    };

                    const syncFocusablesToActive = () => {
                        const slides = mainSplide.Components?.Elements?.slides || [];
                        slides.forEach((slideEl, idx) => setSlideFocusable(slideEl, idx === mainSplide.index));
                    };

                    // If focus lands inside a slide, ensure that slide becomes active
                    mpElem.addEventListener(
                        'focusin',
                        (event) => {
                            const target = event.target;
                            if (!target) return;
                            const slideEl = target.closest && target.closest('.splide__slide');
                            if (!slideEl) return;
                            // Map DOM slide element -> Splide index (getAt expects an index, not an element).
                            const domSlides = mainSplide.Components?.Elements?.slides || [];
                            let idx = domSlides.indexOf(slideEl);
                            if (idx < 0 && slideEl.id) {
                                // Fallback: parse "...-slide07" pattern
                                const m = slideEl.id.match(/-slide(\d+)$/);
                                if (m) idx = parseInt(m[1], 10) - 1;
                            }
                            if (idx < 0 || Number.isNaN(idx)) return;
                            if (idx != null && idx !== mainSplide.index) {
                                mainSplide.go(idx);
                            }
                        },
                        true
                    );

                    mainSplide.on('mounted', syncFocusablesToActive);
                    // Use rAF to wait for Splide to update aria-hidden/classes before toggling tabindex.
                    mainSplide.on('move', () => requestAnimationFrame(syncFocusablesToActive));
                    mainSplide.on('moved', syncFocusablesToActive);
                    mainSplide.on('resized', syncFocusablesToActive);

                    if (track) {

                        const setMainTrackHeight = () => {

                            const slideEl = mainSplide.Components.Slides.getAt(mainSplide.index);

                            const el =

                                slideEl && slideEl.slide

                                    ? slideEl.slide

                                    : mainSplide.Components.Elements.slides[mainSplide.index];

                            if (!el) return;

                            let h = el.offsetHeight;

                            if (!h && el.querySelector('img')) {

                                const img = el.querySelector('img');

                                if (img.naturalWidth && img.naturalHeight)

                                    h =

                                        (el.offsetWidth || img.offsetWidth) *

                                        (img.naturalHeight / img.naturalWidth);

                            }

                            if (h) track.style.setProperty('height', h + 'px', 'important');

                        };

                        const runAfterLayout = (fn) => {

                            requestAnimationFrame(() => requestAnimationFrame(fn));

                        };

                        mainSplide.on('move', () => runAfterLayout(setMainTrackHeight));

                        mainSplide.on('moved', setMainTrackHeight);

                        mainSplide.on('mounted', setMainTrackHeight);

                        mainSplide.on('resized', setMainTrackHeight);

                        runAfterLayout(setMainTrackHeight);

                        setTimeout(setMainTrackHeight, 100);

                        setTimeout(setMainTrackHeight, 400);

                    }

                }

                this.slider = mpInstance.splide;

                break;

            case 'default':

                const elem = this.querySelector('.splide');

                const options = JSON.parse(elem.getAttribute('data-splide'));

                const instance = initializeSplide(elem, options, true);

                const splide = instance.splide;



                if (this.dataset.goTo === 'true') {

                    document.addEventListener('shopify:block:select', (event) => {

                        if (!event.target.classList.contains('splide__slide')) return;

                        const findSlideByBlockId = splide.Components.Slides.filter(

                            `#${event.target.id}`

                        )[0];

                        if (!findSlideByBlockId) return;

                        splide.go(findSlideByBlockId.index);

                    });

                }

                if (this.dataset.customArrows === 'true') SplideSlider.customArrows(splide);

                if (this.dataset.customPager === 'true') SplideSlider.customPager(splide);



                const defPrev = this.querySelector('[data-gallery-prev]');

                const defNext = this.querySelector('[data-gallery-next]');

                if (defPrev) defPrev.addEventListener('click', () => splide.go(String.fromCharCode(60)));

                if (defNext) defNext.addEventListener('click', () => splide.go(String.fromCharCode(62)));



                const paginationTarget = this.querySelector('[data-pagination-target]');

                if (paginationTarget) {

                    const movePag = () => {

                        const pag = elem.querySelector('.splide__pagination');

                        if (pag && !paginationTarget.contains(pag)) {

                            paginationTarget.appendChild(pag);

                        }

                    };

                    splide.on('mounted', movePag);

                    movePag();

                }



                this.slider = splide;

                break;

            default:

                break;

        }

    }

    static inactiveEvent(currentSlide) {

        /* window.pauseElementBasedMedia(currentSlide.slide); */

    }



    static goToReference(currentIndex) {

        document

            .querySelector('[data-main-thumbs] .splide__list')

            ?.children[currentIndex]?.scrollIntoView({

                behavior: 'smooth',

                block: 'center',

            });

    }



    static customArrows(splide) {

        function goPrev() {

            splide.go(String.fromCharCode(60));

        }



        function goNext() {

            splide.go(String.fromCharCode(62));

        }



        function addListenersToActiveSlide() {

            const activeSlide = splide.Components.Elements.slides[splide.index];

            const prevButton = activeSlide.querySelector('[data-splide-prev]');

            const nextButton = activeSlide.querySelector('[data-splide-next]');

            if (prevButton) prevButton.addEventListener('click', goPrev);

            if (nextButton) nextButton.addEventListener('click', goNext);

        }



        function removeListenersFromInactiveSlide(slide) {

            const prevButton = slide.querySelector('[data-splide-prev]');

            const nextButton = slide.querySelector('[data-splide-next]');

            if (prevButton) prevButton.removeEventListener('click', goPrev);

            if (nextButton) nextButton.removeEventListener('click', goNext);

        }

        addListenersToActiveSlide();

        splide.on('active', addListenersToActiveSlide);

        splide.on('inactive', (slide) => removeListenersFromInactiveSlide(slide.slide));

    }



    static customPager(splide) {

        function goTo(event) {

            const index = Number(event.target.dataset.splidePager);

            splide.go(index);

        }



        function addListenersToActiveSlide() {

            const activeSlide = splide.Components.Elements.slides[splide.index];

            const buttons = activeSlide.querySelectorAll('[data-splide-pager]');

            buttons.forEach((button) => button.addEventListener('click', goTo));

        }



        function removeListenersFromInactiveSlide(slide) {

            const buttons = slide.querySelectorAll('[data-splide-pager]');

            buttons.forEach((button) => button.removeEventListener('click', goTo));

        }

        addListenersToActiveSlide();

        splide.on('active', addListenersToActiveSlide);

        splide.on('inactive', (slide) => removeListenersFromInactiveSlide(slide.slide));

    }

}

if (!customElements.get('splide-slider')) customElements.define('splide-slider', SplideSlider);



class SliderButton extends HTMLElement {

    connectedCallback() {

        const button = this.querySelector('button');

        if (!button) return;

        this.button = button;

        button.addEventListener('click', this.handleClick.bind(this));

        this.initObserver();

    }



    initObserver() {

        const sliderWrapper = document.querySelector(this.dataset.sliderTarget);

        if (!sliderWrapper) return;



        const attach = () => {

            if (this.splide) return true;

            const splide =

                sliderWrapper.slider || sliderWrapper.querySelector('.splide')?.splide;

            if (!splide) return false;

            this.splide = splide;

            splide.on('move', () => this.updateDisabledState());

            splide.on('mounted', () => this.updateDisabledState());

            splide.on('updated', () => this.updateDisabledState());

            this.updateDisabledState();

            return true;

        };



        if (attach()) return;



        sliderWrapper.addEventListener(

            'splide-slider:ready',

            () => {

                attach();

            },

            { once: true }

        );



        let n = 0;

        const max = 120;

        const poll = () => {

            if (attach()) return;

            if (n++ < max) requestAnimationFrame(poll);

        };

        requestAnimationFrame(poll);

    }



    handleClick(event) {

        event.preventDefault();

        const splide = this.splide;

        if (!splide) return;

        if (this.querySelector('.splide__arrow--next')) {

            splide.go(String.fromCharCode(62));

        } else {

            splide.go(String.fromCharCode(60));

        }

    }



    updateDisabledState() {

        const splide = this.splide;

        if (!splide) return;

        const currentIndex = splide.index;

        const slideCount = splide.Components.Slides.getLength();

        const lastIndex = slideCount - 1;

        const isLoop = splide.options.type === 'loop';

        const isNext = this.querySelector('.splide__arrow--next');

        const isPrev = this.querySelector('.splide__arrow--prev');



        if (!isLoop) {

            if (isPrev) {

                this.button.disabled = currentIndex === 0;

            }

            if (isNext) {

                this.button.disabled = currentIndex === lastIndex;

            }

        } else {

            this.button.disabled = false;

        }

    }

}



if (!customElements.get('slider-button')) {

    customElements.define('slider-button', SliderButton);

}



function syncMainAndThumbs(sectionId) {

    const mainEl = document.querySelector(`#main-slider-${sectionId}`);

    const thumbsEl = document.querySelector(`#thumbs-slider-${sectionId}`);

    if (!mainEl || !thumbsEl) return;

    const main = mainEl.slider || mainEl.querySelector('.splide')?.splide;

    const thumbs = thumbsEl.slider || thumbsEl.querySelector('.splide')?.splide;

    if (!main || !thumbs) return;

    if (main._syncedWithThumbs) return;

    main._syncedWithThumbs = true;

    main.sync(thumbs);

    thumbs.sync(main);

    thumbs.on('click', (slide) => {

        main.go(slide.index);

    });

}



document.addEventListener('DOMContentLoaded', () => {

    document.querySelectorAll('[id^="main-slider-"]').forEach((mainEl) => {

        const sectionId = mainEl.id.replace('main-slider-', '');

        const thumbsEl = document.querySelector(`#thumbs-slider-${sectionId}`);

        if (!thumbsEl) return;



        const trySync = () => syncMainAndThumbs(sectionId);

        trySync();

        mainEl.addEventListener('splide-slider:ready', trySync, { once: true });

        thumbsEl.addEventListener('splide-slider:ready', trySync, { once: true });



        let n = 0;

        const maxTicks = 40;

        const id = setInterval(() => {

            trySync();

            const main = document.querySelector(`#main-slider-${sectionId}`)?.slider;

            if (main?._syncedWithThumbs || ++n >= maxTicks) clearInterval(id);

        }, 200);

    });

});

